import api, { handleApiResponse } from './api';
import { ApiResponse, PaymentInstallment } from '../types';

interface MarkAsPaidRequest {
  payment_installment_id: number;
  payment_date: string;
  accounting_date: string;
  payment_source: 'CASHBOX' | 'CURRENT_ACCOUNT';
  cash_box_id?: number;
  customer_current_account_id?: number;
  cost_center_id?: number;
  perceptions: number;
  comments?: string;
  payment_methods?: {
    method: string;
    amount: number;
  }[];
}

// Interfaces for the new grouped API response structure

export interface Installment {
  installmentId: number;
  amount: number;
  adjustedAmount: number;
  /** Primer día del mes al que se ajustó (puede diferir de dueDate si faltan datos CAC futuros). */
  adjustedToMonth: string | null;
  /** True si adjustedToMonth es estimación (mes de vencimiento sin datos CAC aún). */
  isAdjustedEstimate: boolean | null;
  dueDate: string;
  isPaid: boolean;
  paymentDate: string | null;
  accountingDate: string | null;
  cashRegister: string | null;
  costCenter: string | null;
  perceptions: number | null;
  comments: string | null;
  createdAt: string;
  updatedAt: string;
  moraAmount?: number | null;
  moraTotalAmount?: number | null;
  currentMoraPreview?: number | null;
}

export interface Payment {
  paymentId: number;
  currency: string;
  paymentType: string;
  accountingType: string;
  description: string | null;
  baseAmount: number;
  totalAmount: number;
  exchangeRate: number;
  generalPaymentDate: string | null;
  iva: number;
  financingType: string | null;
  firstInstallmentDate: string | null;
  totalInstallments: number | null;
  indexationType: string | null;
  indexBaseDate: string | null;
  moraRate?: number | null;
  moraFrequency?: string | null;
}

export interface Sale {
  saleId: number;
  deliveryDate: string;
  currency: string;
  total: number;
}

export interface PaymentGroupResponse {
  payment: Payment;
  sale: Sale;
  installments: Installment[];
}

export const paymentInstallmentService = {
  /**
   * Obtener todas las cuotas de pago de un cliente agrupadas por payment
   * @param customerId - ID del cliente
   * @returns Promise con la lista de cuotas del cliente agrupadas por payment
   */
  async getCustomerInstallments(
    customerId: number,
  ): Promise<PaymentGroupResponse[]> {
    const response = await api.get<ApiResponse<PaymentGroupResponse[]>>(
      `/payment-installments/customer/${customerId}`,
    );
    return handleApiResponse(response);
  },

  /**
   * Marcar una cuota como pagada
   * @param paymentData - Datos del pago a registrar
   * @returns Promise con la cuota actualizada
   */
  async markAsPaid(
    paymentData: MarkAsPaidRequest,
  ): Promise<PaymentInstallment> {
    const response = await api.put<ApiResponse<PaymentInstallment>>(
      `/payment-installments/mark-as-paid`,
      paymentData,
    );
    return handleApiResponse(response);
  },
};
